import axios from 'axios';

// base ure to make request to thr movie database

const instance = axios.create({
  baseURL: 'https://api.themoviedb.org/3',
});

export default instance;
